import React from 'react';
import { Outlet, Link } from "react-router-dom";
import images from '../../helpers/images';
import helpers from '../../helpers/helpers';
import appSession from '../../helpers/session';

function Header(){
    
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <Link className="navbar-brand" to="/">
                        <img src={images.mainLogo} />
                    </Link>
                    <div className="justify-content-around" id="navbarTogglerDemo03">
                        <form className="example d-flex" action="#">

                            <div className='d-flex align-items-center'>

                                {
                                    helpers.isAuthenticated() ?
                                    <>
                                    <img src={images.profileIcon} alt="profile" className="profile mb-0" />
                                    <Link className="login" to="/profile">{helpers.getUserName()}</Link>

                                    <Link className="login ms-4" to="/dashboard">My&nbsp;Dashboard</Link>

                                    {helpers.displayAdminLink()}
                                    </>
                                    : 
                                    <Link className="login" to="/login">Login / Registration</Link>
                                }
                            </div>

                            {
                                helpers.isAuthenticated() && 
                                <>
                                <button type='button' className='btn px-3 ms-4' onClick={() => appSession.logout()}>Logout</button></>
                            }
                        </form>
                    </div>
                </div>
            </nav>


            <Outlet />
        </>
    )
}

export default Header;